import { cn } from "@/shared/lib/utils"

type ElementProps<E extends React.ElementType = React.ElementType> = { as?: E }

type SkeletonProps<E extends React.ElementType> = ElementProps<E> & Omit<React.ComponentProps<E>, keyof ElementProps>

export const Skeleton = <E extends React.ElementType = "div">({ className, as, ...props }: SkeletonProps<E>) => {
  const Tag = as || "div"

  return (
    <Tag
      {...props}
      className={cn("animate-pulse rounded bg-gray-700/60 motion-reduce:animate-none", className)}
    />
  )
}
